import { render } from "./AccessError.vue?vue&type=template&id=2562a899&scoped=true"
import script from "./AccessError.vue?vue&type=script&lang=js"
export * from "./AccessError.vue?vue&type=script&lang=js"

import "./AccessError.vue?vue&type=style&index=0&id=2562a899&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2562a899"

export default script